import { _ } from "~/i18n";
import { node } from "~/util/dom";

interface ISharing {
	author?: string;
}

export function createMyMapsSharing({
	author = "",
}: ISharing) {
	const container = node("p", { className: "mymaps-sharing", textContent: `${_("detail.content.mymapsplace.author")} ${author}` });

	return container;
}
